import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-popup-password-template",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./popup-password-template.component.html",
})
export class PopupPasswordTemplateComponent {}
